import { PayloadAction, createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchMyAffiliates } from 'services/affiliates'
import { MyAffiliate } from 'types'
import { fetchAffiliateThunk } from './affiliate'
import { batch } from 'react-redux'
import * as localStorageService from 'services/cookies'

type InitialState = {
  myAffiliates?: MyAffiliate[]
  selectedAffiliate?: MyAffiliate
  isLoading: boolean
}

const initialState: InitialState = {
  myAffiliates: null,
  selectedAffiliate: null,
  isLoading: true,
}

export const fetchAffiliates = createAsyncThunk(
  'myAffiliates',
  async (userId: number, { dispatch }) => {
    const affiliates = await fetchMyAffiliates(userId)
    const cookieAffiliateId = localStorageService.getSelectedAffiliateId()

    if (cookieAffiliateId) {
      dispatch(fetchAffiliateThunk(cookieAffiliateId))
    } else if (affiliates.length) {
      dispatch(fetchAffiliateThunk(affiliates[0].affiliateId))
    }

    return affiliates
  },
)

export const selectAffiliateThunk = createAsyncThunk(
  'selectAffiliate',
  async (affiliate: MyAffiliate, { dispatch }) => {
    localStorageService.setSelectedAffiliateId(affiliate.affiliateId)
    batch(() => {
      dispatch(fetchAffiliateThunk(affiliate.affiliateId))
      dispatch(updateSelectedAffiliate(affiliate))
    })
  },
)

export const myAffiliatesSlice = createSlice({
  name: 'myAffiliates',
  initialState: initialState,
  reducers: {
    updateMyAffiliates: (state, action: PayloadAction<MyAffiliate[]>) => {
      state.myAffiliates = action.payload
      return state
    },
    updateSelectedAffiliate: (state, action: PayloadAction<MyAffiliate>) => {
      state.selectedAffiliate = action.payload

      return state
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        fetchAffiliates.fulfilled,
        (state, action: PayloadAction<MyAffiliate[]>) => {
          state.myAffiliates = action.payload ?? []
          state.isLoading = false

          if (action.payload?.length) {
            const cookieAffiliateId =
              localStorageService.getSelectedAffiliateId()
            const cookieAffilliate = action.payload.find(
              (a) => a.affiliateId === cookieAffiliateId,
            )

            if (cookieAffilliate) {
              state.selectedAffiliate = cookieAffilliate
            } else {
              state.selectedAffiliate = action.payload[0]
            }
          }

          return state
        },
      )
      .addCase(fetchAffiliates.pending, (state) => {
        state.isLoading = true

        return state
      })
      .addCase(fetchAffiliates.rejected, (state) => {
        state.isLoading = false

        return state
      })
  },
})

export const { updateMyAffiliates, updateSelectedAffiliate } =
  myAffiliatesSlice.actions
export default myAffiliatesSlice.reducer
